var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.928589,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#00A3FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92859 20.6482C9.99811 20.3898 10.071 20.1324 10.1362 19.8728C10.3113 19.1766 10.4812 18.4792 10.6587 17.7835C10.677 17.7119 10.7198 17.6378 10.772 17.5855C12.9345 15.4167 15.0991 13.2501 17.2637 11.0835C17.2856 11.0616 17.309 11.0411 17.3217 11.0293C18.1762 11.8847 19.0278 12.7369 19.8893 13.599C19.878 13.6113 19.8513 13.6424 19.8224 13.6713C17.6689 15.8268 15.5155 17.9826 13.3591 20.1353C13.2965 20.1977 13.208 20.2497 13.1226 20.2716C12.1897 20.51 11.2551 20.7414 10.321 20.9753C10.2988 20.9808 10.2781 20.9916 10.2567 21.0001C10.2098 21.0001 10.1629 21.0001 10.1162 21.0001C10.0537 20.9374 9.99114 20.8751 9.92883 20.8125C9.92859 20.7578 9.92859 20.7029 9.92859 20.6482Z",
    fill: "#00A3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6571 12.8358C19.7973 11.9754 18.9448 11.1221 18.0852 10.2617C18.3164 10.03 18.5519 9.79187 18.7903 9.55683C18.8986 9.45015 19.0042 9.33793 19.1257 9.24811C19.6046 8.89387 20.31 8.91963 20.7505 9.32107C21.0504 9.5944 21.3384 9.88266 21.6107 10.1834C22.0149 10.6299 22.032 11.31 21.6721 11.7952C21.6256 11.8576 21.5737 11.9166 21.5188 11.972C21.2306 12.2626 20.941 12.5516 20.6571 12.8358Z",
    fill: "#00A3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.91f65466389a7499e267f423d08e5cbb.svg";
export { ForwardRef as ReactComponent };